<template>
  <div id="app">
    <div style='width:200px;height:40px;border:1px solid red;'>
    <common-button-group></common-button-group>
    </div>
    <div style="margin-top:30px;"></div>
    <common-header-bar></common-header-bar>
    <div style="margin-top:30px;"></div>
    <common-nav-menu :dataList='menuList'></common-nav-menu>
    <div style="margin-top:30px;"></div>
    <common-echart type="bar" height="200px" width="600px" :dataList="lineAndBarDataList"></common-echart>
    <div style="margin-top:30px;"></div>
    <common-card width="30%"></common-card>
    <div style="margin-top:30px;"></div>
    <common-card-bar>
      <template slot="title">测试数据</template>
      <template slot="desp">描述描述描述描述描述</template>
      <template slot="time">2020-06-15</template>
      <template slot="operate">
        <el-button type='primary'>申请</el-button>
        <el-button  type='primary'>收藏</el-button>
      </template>
    </common-card-bar>
  </div>
</template>

<script>
// import buttonGroup from "../package/basicComponents/buttonGroup/index";
// import headerBar from "../package/basicComponents/headerBar/index";
// import navMenu from "../package/bizComponents/navMenu/index";
// import echarts from "../package/basicComponents/echarts/index";
// import card from "../package/bizComponents/card/index";
// import cardBar from "../package/bizComponents/cardBar/index";
export default {
  // components: { buttonGroup, headerBar, navMenu, echarts, card, cardBar },
  name: "App",
  data() {
    return {
       menuList: [
        {
          icon: "",
          menuName: "位置能力中心",
          path: ""
        },
        {
          icon: "",
          menuName: "位置服务定制",
          path: ""
        }
      ],
      lineDataList: {
        optionSet: {
          lineWidth: 2,
          unit1: "万"
        },
        xList: ["201909", "201910", "201911", "201912", "202001", "202002"],
        yList: [
          {
            type: "line",
            data: [1000, 2000, 2500, 3000, 3500, 1800]
          }
        ]
      },
      lineAndBarDataList: {
        optionSet: {
          lineWidth: 2,
          unit1: "万"
        },
        xList: ["201909", "201910", "201911", "201912", "202001", "202002"],
        yList: [
          {
            type: "bar",
            areacolor: ["#142850", "#142850"],
            data: [100, 200, 250, 300, 350, 180]
          },
          {
            type: "line",
            color: ["#142850", "#142850"],
            data: [10, 20, 25, 30, 35, 18]
          }
        ]
      }
    };
  },
  mounted() {
    let arr = [32, 56, 34, 34, 57, 57];
    console.log(this.$fn.dedupe(arr));

    console.log(this.$fn.getYestodayDate());

    //let base=new this.$baseStorage('np',1);
    let base = new this.$baseStorage("np", "1");
    base.set("item", "123");
    base.get("item", (status, value) => {
      console.log(value);
    });
  }
};
</script>

<style scoped lang="scss">
#app {
  margin: 0 auto 50px;
  width: 800px;
  background: #f5f5f5;
  padding-bottom: 40px;
}
</style>
